import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import './index.css';
import { registerServiceWorker } from './pwa';

const container = document.getElementById('root');
if (!container) throw new Error('#root not found');

registerServiceWorker();

// Replaces the inline splash from index.html on first render.
createRoot(container).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
